<div class="mx-auto w-full h-full justify-center space-y-6 sm:w-96">
  <div class="space-y-2 text-center">
    <h1 class="text-2xl font-semibold tracking-tight">
      @if (hasStoredCredentials()) {
        Imposta nuova password
      } @else {
        Reimposta password
      }
    </h1>
    <p class="text-muted-foreground text-sm">
      @if (hasStoredCredentials()) {
        Scegli una nuova password per il tuo account
      } @else {
        Inserisci la password temporanea e la nuova password
      }
    </p>
  </div>
  <div class="grid gap-6">
    <form [formGroup]="form" (ngSubmit)="resetPassword()" class="space-y-4">
      @if (errorMessage()) {
        <p class="text-destructive text-sm text-center">
          {{ errorMessage() }}
        </p>
      }

      @if (!hasStoredCredentials()) {
        <div class="space-y-2">
          <label hlmLabel> Email </label>
          <input
            hlmInput
            class="w-full"
            type="email"
            id="email"
            formControlName="email"
            placeholder="nome@esempio.com"
            autocomplete="off"
          />
        </div>

        <div class="space-y-2">
          <label hlmLabel> Password temporanea </label>
          <o2-password-input
            class="w-full"
            id="temporaryPassword"
            formControlName="temporaryPassword"
            placeholder="Password temporanea"
          />
        </div>
      }

      <div class="space-y-2">
        <label hlmLabel>Nuova password</label>
        <o2-password-input
          class="w-full"
          id="newPassword"
          formControlName="newPassword"
          placeholder="Nuova password"
        />
      </div>

      <div class="space-y-2">
        <label hlmLabel>Conferma password</label>
        <o2-password-input
          class="w-full"
          id="confirmPassword"
          formControlName="confirmPassword"
          placeholder="Conferma password"
        />
      </div>

      <!-- Password requirements checklist -->
      <div class="text-sm space-y-1">
        <p class="text-muted-foreground font-medium mb-2">
          La password deve contenere:
        </p>
        <div
          class="flex items-center gap-2"
          [class.text-green-600]="passwordValidation.minLength"
          [class.text-muted-foreground]="!passwordValidation.minLength"
        >
          <ng-icon
            hlm
            [name]="passwordValidation.minLength ? 'lucideCheck' : 'lucideX'"
            size="sm"
          />
          <span>Almeno 8 caratteri</span>
        </div>
        <div
          class="flex items-center gap-2"
          [class.text-green-600]="passwordValidation.uppercase"
          [class.text-muted-foreground]="!passwordValidation.uppercase"
        >
          <ng-icon
            hlm
            [name]="passwordValidation.uppercase ? 'lucideCheck' : 'lucideX'"
            size="sm"
          />
          <span>Una lettera maiuscola</span>
        </div>
        <div
          class="flex items-center gap-2"
          [class.text-green-600]="passwordValidation.lowercase"
          [class.text-muted-foreground]="!passwordValidation.lowercase"
        >
          <ng-icon
            hlm
            [name]="passwordValidation.lowercase ? 'lucideCheck' : 'lucideX'"
            size="sm"
          />
          <span>Una lettera minuscola</span>
        </div>
        <div
          class="flex items-center gap-2"
          [class.text-green-600]="passwordValidation.number"
          [class.text-muted-foreground]="!passwordValidation.number"
        >
          <ng-icon
            hlm
            [name]="passwordValidation.number ? 'lucideCheck' : 'lucideX'"
            size="sm"
          />
          <span>Un numero</span>
        </div>
        <div
          class="flex items-center gap-2"
          [class.text-green-600]="passwordValidation.specialChar"
          [class.text-muted-foreground]="!passwordValidation.specialChar"
        >
          <ng-icon
            hlm
            [name]="passwordValidation.specialChar ? 'lucideCheck' : 'lucideX'"
            size="sm"
          />
          <span>Un carattere speciale (!&#64;#$%...)</span>
        </div>
        @if (form.get("confirmPassword")?.value) {
          <div
            class="flex items-center gap-2 mt-2"
            [class.text-green-600]="passwordsMatch"
            [class.text-destructive]="!passwordsMatch"
          >
            <ng-icon
              hlm
              [name]="passwordsMatch ? 'lucideCheck' : 'lucideX'"
              size="sm"
            />
            <span>Le password coincidono</span>
          </div>
        }
      </div>

      <button hlmBtn [disabled]="isLoading()" class="mt-4 w-full">
        @if (isLoading()) {
          <hlm-spinner class="mr-2" />
        }
        @if (hasStoredCredentials()) {
          Imposta password
        } @else {
          Reimposta password
        }
      </button>

      <button
        hlmBtn
        variant="link"
        [disabled]="isLoading()"
        class="mt-4 w-full"
        (click)="onSignInClick()"
        type="button"
      >
        Torna al login
      </button>

      @if (!hasStoredCredentials()) {
        <button
          hlmBtn
          variant="link"
          [disabled]="isLoading()"
          class="mt-4 w-full"
          (click)="onForgotPasswordClick()"
          type="button"
        >
          Password dimenticata?
        </button>
      }
    </form>
  </div>
</div>
